import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { createApp } from 'vue';

import App from './App.vue';
import { i18n } from './i18n';
import { installAbility } from './plugins/ability';
import { router } from './router';
import { useAppStore } from './stores/app.store';

import './assets/styles/main.css';

const app = createApp(App);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(pinia);
app.use(i18n);
app.use(router);
installAbility(app);

const appStore = useAppStore();
appStore.initializeLocale();
appStore.updateDocumentTheme();

app.mount('#app');
